import { z } from 'zod';

export const createPromoOfferSchema = z.object({
  venue_id: z.number({
    required_error: 'Venue is required',
    invalid_type_error: 'Venue is required',
  }).positive('Venue is required'),
  
  brand: z.string()
    .max(255, 'Brand name must be 255 characters or less')
    .optional()
    .transform(val => val === '' ? undefined : val),
  
  short_description: z.string()
    .min(1, 'Short description is required')
    .max(255, 'Short description must be 255 characters or less'),
  
  detailed_description: z.string()
    .max(1000, 'Detailed description must be 1000 characters or less')
    .optional()
    .transform(val => val === '' ? undefined : val),
  
  media_url: z.string()
    .url('Media URL must be a valid URL')
    .optional()
    .or(z.literal('')),
  
  expires_at: z.date({
    required_error: 'Expiry date is required',
    invalid_type_error: 'Invalid expiry date',
  }).refine(
    (date) => date > new Date(),
    'Expiry date must be in the future'
  ),
  
  max_claim_per_person: z.number({
    required_error: 'Max claims per person is required',
    invalid_type_error: 'Max claims per person must be a number',
  })
    .int('Max claims per person must be a whole number')
    .min(1, 'Max claims per person must be at least 1')
    .max(100, 'Max claims per person must be 100 or less')
    .default(1),
  
  max_claim_total: z.number({
    required_error: 'Max total claims is required',
    invalid_type_error: 'Max total claims must be a number',
  })
    .int('Max total claims must be a whole number')
    .min(1, 'Max total claims must be at least 1'),
  
  is_active: z.boolean().default(true),
});

export const updatePromoOfferSchema = z.object({
  promo_code: z.string()
    .min(1, 'Promo code is required')
    .max(50, 'Promo code must be 50 characters or less')
    .optional(),
    
  brand: z.string()
    .max(255, 'Brand name must be 255 characters or less')
    .optional()
    .transform(val => val === '' ? undefined : val),
  
  short_description: z.string()
    .min(1, 'Short description is required')
    .max(255, 'Short description must be 255 characters or less')
    .optional(),
  
  detailed_description: z.string()
    .max(1000, 'Detailed description must be 1000 characters or less')
    .optional()
    .transform(val => val === '' ? undefined : val),
  
  media_url: z.string()
    .url('Media URL must be a valid URL')
    .optional()
    .or(z.literal('')),
  
  expires_at: z.date({
    invalid_type_error: 'Invalid expiry date',
  }).refine(
    (date) => date > new Date(),
    'Expiry date must be in the future'
  ).optional(),
  
  max_claim_per_person: z.number({
    invalid_type_error: 'Max claims per person must be a number',
  })
    .int('Max claims per person must be a whole number')
    .min(1, 'Max claims per person must be at least 1')
    .max(100, 'Max claims per person must be 100 or less')
    .optional(),
  
  max_claim_total: z.number({
    invalid_type_error: 'Max total claims must be a number',
  })
    .int('Max total claims must be a whole number')
    .min(1, 'Max total claims must be at least 1')
    .optional(),
  
  is_active: z.boolean().optional(),
});

export type CreatePromoOfferInput = z.infer<typeof createPromoOfferSchema>;
export type UpdatePromoOfferInput = z.infer<typeof updatePromoOfferSchema>;